import { ExamineOutputApi } from '../apis';
import { handleData } from './response.handler';

export const ExamineOutputService = {
  getThermalData,
  getThermalImages
};

async function getThermalData(thermalImageId){
  const response = await ExamineOutputApi
    .getThermalData(thermalImageId);
  return handleData(response);
}

async function getThermalImages(reportId, showAiDefectFlag, axiosConfig){
  const response = await ExamineOutputApi
    .getThermalImages(reportId, showAiDefectFlag, axiosConfig);
  return handleData(response);
}
